import { useDispatch, useSelector } from 'react-redux'

import CustomersFilter from '@/components/customers/CustomersFilter'
import Button from '@/components/form/Button'
import { Translation } from '@/components/i18n/Translation'
import { getCustomerFromId, getFilteredCustomers } from '@/ducks/customersReducer'
import { getCustomerId, setCustomerId } from '@/ducks/shopOrderReducer'
import { increaseStep } from '@/ducks/shopProgressReducer'
import withCustomersLoaded from '@/hocs/withCustomersLoaded'
import withQuoteCustomerLoaded from '@/hocs/withQuoteCustomerLoaded'

import './step-customer.scss'

const StepCustomer = () => {
  const customers = useSelector(getFilteredCustomers)
  const customerId = useSelector(getCustomerId)

  return (
    <div className="shop-step__customer__selection">
      {customerId ? (
        <SelectedCustomer customerId={customerId} />
      ) : (
        <>
          <CustomersFilter />
          <table>
            <tbody>
              {customers.map(customer => (
                <Customer key={customer.id} {...customer} />
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  )
}

export default withCustomersLoaded(StepCustomer)

const Customer = ({ id, name, orgNumber, customerHeadName }: any) => {
  const dispatch = useDispatch()

  return (
    <tr>
      <td>{customerHeadName}</td>

      <td>{name}</td>

      <td>{orgNumber}</td>

      <td className="number">
        <Button onClick={() => dispatch(setCustomerId(id))}>
          <Translation id="Select this customer" />
        </Button>
      </td>
    </tr>
  )
}

const SelectedCustomer = withQuoteCustomerLoaded(({ customerId }: any) => {
  const dispatch = useDispatch()

  const { name, customerHeadName, orgNumber } =
    useSelector(state => getCustomerFromId(state, customerId)) || {}

  return (
    <div className="shop-step__customer__confirmation">
      <h2>
        <Translation id="Selected Customer" />
      </h2>

      <h3>{customerHeadName}</h3>

      <p>{name}</p>

      <p>{orgNumber}</p>
      {/* @ts-ignore */}
      <Button onClick={() => dispatch(increaseStep())}>
        <Translation id="Next" />
      </Button>
    </div>
  )
})
